export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('addCard', {
    component: 'fizyPaycellCardAdd',
    parent: 'buy',
    url: '/add-card'
  });
}



// WEBPACK FOOTER //
// ./src/app/buy/paycell-card-add/paycell-card-add.routes.ts